import {
  action,
  observable,
  useStrict
} from 'mobx';

import {
  observer
} from 'mobx-react';

import AppState from '../AppState';

useStrict();

const TrendingSearchState = {
  iteration: 0,
  items: [],

  get maxTagsCount() {
    return AppState.compactMode ? 5 : 10;
  },

  get terms() {
    return AppState.data ? AppState.data.sections.trending.terms : [];
  },

  get activeTerms() {
    const terms = [];
    this.items.forEach((item) => {
      terms.push(item.term.label);
    });
    return terms;
  },

  get inactiveTerms() {
    const terms = [];
    this.terms.forEach((term) => {
      if (this.activeTerms.indexOf(term.label) === -1) terms.push(term);
    });
    return terms;
  },
  
  get height() {
    return AppState.windowHeight * 0.8;
  },
  
  get width() {
    const margins = AppState.windowWidth * 0.2;
    const minMargins = 200;
    return AppState.windowWidth - (margins < minMargins ? minMargins : margins);
  },

  get itemRadius() {
    return 200;
  },

  get grid() {
    const {
      windowWidth,
      windowHeight
    } = AppState;

    const area = windowWidth * windowHeight;
    const density = 1 / 20000;
    const items = area * density;

    return items;
  },

  initItem: action(function() {
    const activeTerms = []
    const inactiveTerms = [];

    this.items.forEach((item) => {
      activeTerms.push(item.term.label);
    });

    this.terms.forEach((term) => {
      if (activeTerms.indexOf(term.label) === -1) inactiveTerms.push(term);
    });

    if (inactiveTerms.length > 0 && this.items.length < this.maxTagsCount) {
      const item = {
        key: Math.random(),
        term: inactiveTerms[Math.floor(Math.random() * inactiveTerms.length)],
        position: {
          x: Math.random(),
          y: Math.random(),
        },
      }
      this.items.push(item);
    }
  }),

  destroyItem: action(function(itemToDestroy) {
    this.items.forEach((item) => {
      if (item.term.label === itemToDestroy.term.label) {
        this.items.remove(itemToDestroy);
        this.initItem();
      }
    });
  }),
};

export default observer(observable(TrendingSearchState));



// WEBPACK FOOTER //
// ./src/states/TrendingSearchState/index.js